import {
  Component,
  inject,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IQ_ACTION_LABEL_DISPLAY } from 'src/app/shared/constants/iq-observation-action-labels';

@Component({
  selector: 'app-historical-observations-modal',
  templateUrl: './historical-observations-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HistoricalObservationsModalComponent {
  readonly iqActionLabelDisplay = IQ_ACTION_LABEL_DISPLAY;

  dialogRef = inject(MatDialogRef<HistoricalObservationsModalComponent>);

  data = inject(MAT_DIALOG_DATA) as {
    observations: any[];
    serviceName: string;
  };

  close(): void {
    this.dialogRef.close();
  }
}
